export const updateUser = '/user';
export const getUserNotificationSetting = '/notifications/get-user-notification';
export const updateUserNotificationSetting = '/notifications/update-notification';
export const getUserPreferences = '/user-preferences/get-by-id';
export const updateUserPreferences = '/user-preferences/update-preferences';
export const getMyProfile = '/user/my/profile';
